var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputImgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.25,
    cy: 10.25,
    r: 10.25,
    fill: "#00B087"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42249 15.0354L5.46582 14.0787L9.29249 10.2521L5.46582 6.42542L6.42249 5.46875L10.2492 9.29542L14.0758 5.46875L15.0325 6.42542L11.2058 10.2521L15.0325 14.0787L14.0758 15.0354L10.2492 11.2087L6.42249 15.0354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputImgCloseIcon);
export default __webpack_public_path__ + "static/media/input-img-close-icon.b6e88335c8ad1fdfbe60895c6262dbb0.svg";
export { ForwardRef as ReactComponent };